import {container} from "tsyringe";
import {ListenerInfo} from "./listener-info.interface";
import {MessageBroker} from "./message-broker";

export abstract class AbstractBaseListener {

    private static _listenersMap = new Map<Object, ListenerInfo<any>[]>();

    protected _messageBroker: MessageBroker;

    public constructor() {
        this._messageBroker = container.resolve(MessageBroker);
        this.registerListeners();
    }

    public static addListenerInfo<T extends Record<string, any>>(target: Object, info: ListenerInfo<T>): void {
        if (!AbstractBaseListener._listenersMap.has(target.constructor)) {
            AbstractBaseListener._listenersMap.set(target.constructor, []);
        }
        const listeners = AbstractBaseListener._listenersMap.get(target.constructor)!;
        listeners.push(info);
        listeners.sort((infoA, infoB) => {
            return (infoB.sorting ?? -1) - (infoA.sorting ?? -1);
        });
        AbstractBaseListener._listenersMap.set(target.constructor, listeners);
    }

    private registerListeners(): void {
        const listeners = AbstractBaseListener._listenersMap.get(this.constructor) ?? [];
        listeners.sort(
            (l1, l2) => (l2.sorting ?? -1) - (l1.sorting ?? -1)
        );
        for (const listenerInfo of listeners) {
            this._messageBroker.registerListener(this, listenerInfo);
        }


    }
}